import Vue from "vue"
import VueCurrentMarket from "@/mixins/vue-current-market"

Vue.use(VueCurrentMarket)
